import React from "react"
import { Alert, Drawer, Table as AntTable } from "antd"
import styled from "styled-components"

import { useAppData } from "../../store/app-data"

import { getUserRewardsColumns } from "./rewards-columns"

export function UserRewardsDrawer({ title, onClose, items, isLoading }) {
  const layoutConfig = useAppData((state) => state.layoutConfig)
  const columns = getUserRewardsColumns()

  const waitingForUser = items.filter((item) => item.needsClaim && !item.isClaimed).length

  return (
    <DrawerEdit
      width={layoutConfig.isMobile ? "90%" : "80%"}
      title={title}
      onClose={onClose}
      open
    >
      {waitingForUser > 0 && (
        <StyledAlert
          type="info"
          showIcon
          message={`Ждут действия пользователя: ${waitingForUser}`}
          description="Награду за квест начисляет не система, а сам пользователь — кнопкой «Получить» в приложении. Пока он её не нажал, баллы и промокоды не выдаются, и «Проверить систему лояльности» здесь не поможет."
        />
      )}
      <StyledTable
        dataSource={items}
        columns={columns}
        rowKey="id"
        loading={isLoading}
        pagination={false}
        locale={{ emptyText: "У клиента нет наград" }}
      />
    </DrawerEdit>
  )
}

const DrawerEdit = styled(Drawer)``

const StyledAlert = styled(Alert)`
  margin-bottom: 16px;
`

const StyledTable = styled(AntTable)`
  .ant-table-cell {
    vertical-align: top;
  }
`
